import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Experiences } from '@local/client-contracts';
import { cloneDeep, isEqual } from 'lodash';
import { assistantContent } from '../../helpers/assistant.content';

@Component({
  selector: 'rfp-preferences',
  templateUrl: './rfp-preferences.component.html',
  styleUrls: ['../../base-preferences.scss', './rfp-preferences.component.scss'],
})
export class RfpPreferencesComponent {
  readonly assistantContent = assistantContent;
  assistantId: string;
  viewOnly: boolean;
  rfpProperties: Experiences.ExperienceRfpSettings;

  @Input() set assistant(val: Experiences.ExperienceItem<'rfp'>) {
    const assistantChanged = !this.assistantId || val?.id !== this.assistantId;
    if (assistantChanged || !isEqual(val?.settings, this.rfpProperties)) {
      this.viewOnly = val.permissionRole === 'viewer';
      this.rfpProperties = cloneDeep(val.settings || {});
    }
  }
  @Output() updateProperties = new EventEmitter<Experiences.ExperienceRfpSettings>();
}
